export default __webpack_public_path__ + "static/media/kindness.310c1a12.jpg";